import React from "react";

const FooterPremium = () => {
  return (
    <footer className="border-t border-white/10 bg-navy py-8">
      <div className="section-shell flex flex-col items-center justify-between gap-3 text-center sm:flex-row sm:text-left">
        <p className="text-xs text-slate-400">© {new Date().getFullYear()} B-fos. All rights reserved.</p>
        <p className="text-xs text-slate-500">
          Civil Engineering & Consultancy — Kigali, Rwanda
        </p>
      </div>
    </footer>
  );
};

export default FooterPremium;
